import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PlaceIcon from '@mui/icons-material/Place';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Icons = {
    FacebookOutlinedIcon,
    InstagramIcon,
    MailOutlineIcon,
    PhoneIcon,
    LinkedInIcon,
    PlaceIcon,
    WhatsAppIcon,
    AddIcon,
    RemoveIcon,
    CloseIcon,
    ArrowBackIcon,
  };
  
  export default Icons;